// Where to send someone once they are signed in: the page that asked for the
// account. PrivateRoute stores the page it bounced them from, and the signed-out
// Pick Three page stores the picker before sending a visitor to sign up. Login
// and the sign up code screen both read it back.
//
// sessionStorage, so it lives only as long as the tab. A sign up confirmed from
// the link in the email, in another browser, lands on /home instead.

const KEY = "authRedirect";

/** Remember `path` (same-origin, starting with "/") as the post-sign-in page. */
export function setAuthRedirect(path) {
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    /* the person lands on /home instead */
  }
}

/**
 * Reads and clears the stored destination. The value is always consumed, so a
 * stale entry cannot follow the user into later sessions, and only same-origin
 * paths are honoured: a stored absolute URL would otherwise redirect off the
 * site after a successful sign in. Null when there is nothing safe to use.
 */
export function consumeAuthRedirect() {
  try {
    const stored = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    if (!stored) return null;
    return /^\/(?!\/)/.test(stored) ? stored : null;
  } catch {
    return null;
  }
}
